import { formatCurrency } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormatterHelperService {

  userLanguage: string;

  constructor(){}
  
  formatCurrency(value: number, currency: string): string {
    this.userLanguage = sessionStorage.getItem('LanguageCode') ? sessionStorage.getItem('LanguageCode')
     : navigator.language.split('-')[0]
    return formatCurrency(value, this.userLanguage, currency);
  }
}
